import {useUserInfoStore} from "@/stores/userInfo";
//import router from "@/router";
//import {logger} from "@/utils/logger"
import { inject } from 'vue';
import {
    MDBNavbar,
    MDBNavbarBrand,
    MDBNavbarNav,
    MDBNavbarItem,
    MDBDropdown,
    MDBDropdownToggle,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBAlert,
    MDBBadge,
    MDBTooltip
} from 'mdb-vue-ui-kit';
import {onMounted, ref} from 'vue';
import {storeToRefs} from "pinia";
import axios from "axios";

export default {
    name: 'menuNav,',
    components: {
        MDBNavbar,
        MDBNavbarBrand,
        MDBNavbarNav,
        MDBNavbarItem,
        //MDBCollapse,
        MDBDropdown,
        MDBDropdownToggle,
        MDBDropdownMenu,
        MDBDropdownItem,
        MDBAlert,
        MDBBadge,
        MDBTooltip
    },

    setup() {
        const collapse5 = ref(false);
        const dropdown1 = ref(false);
        const dropdown2 = ref(false);
        const dropdown3 = ref(false);
        const dropdown4 = ref(false);
        const dropdown5 = ref(false);

        const notifications = ref([]);

        const userInfoStore = useUserInfoStore()
        const alert = ref(false);
        const alertColor = ref("success");
        const alertMessage = ref("");
        const showNotification = (type, message) => {
            alertMessage.value = `<strong>${message}</strong>`;
            alertColor.value = type;
            alert.value = true;
        }
        const { admin } =  storeToRefs(userInfoStore)
        const { orgType } =  storeToRefs(userInfoStore)

        const config = inject('appConfig');
        const basePath = config.VUE_APP_BASE_PATH;


        onMounted(async () => {
            await userInfoStore.loadState();
        });

        return {
            collapse5,
            dropdown1,
            dropdown2,
            dropdown3,
            dropdown4,
            dropdown5,
            basePath,
            admin,
            orgType,
            alert,
            alertColor,
            alertMessage,
            showNotification,
            userInfoStore,
            notifications
        }
    },
    computed: {
        loggedIn() {
            return !!this.userInfoStore.currentUserId;
        }
    },
    mounted() {

        if (this.userInfoStore.userId && this.userInfoStore.token) {
            axios
                .get(this.$config.VUE_APP_REDCAP_API_DOMAIN + "notifications?id=" + this.userInfoStore.userId, { withCredentials: true})
                .then(async response => {
                    this.notifications = response.data.notifications.notification_text
                })
                .catch(error => {
                    this.handleError(error);
                    console.error("There was an error!", error);
                    this.isLoading = false
                })
        }


    },
    methods: {
        logout() {
            //this.userInfoStore.$reset()
            //router.push("/login")
        },
        handleError(error) {
            console.error("There was an error!", error);
            if (error.response) {
                if (error.response.data) {
                    if (error.response.data.errors) {
                        this.showNotification('danger', "Errors: " + error.response.data.errors.map(obj => obj.msg).join(", "))
                    } else if (error.response.data.error) {
                        if (error.response.status === 401 || error.response.data.error.includes("TokenExpiredError")) { // logout if token expired
                            this.$router.push("/logout");
                        } else {
                            this.showNotification('danger', "Error: " + error.response.data.error)
                        }
                    } else {
                        this.showNotification('danger', "Error: " + error.response.data)
                    }
                }
            } else {
                this.showNotification('danger', "Error: " + error.message)
            }
        },
    }
};